import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { formatViews } from "@/utils/format";

interface VideoCardProps {
  video: Video;
  compact?: boolean;
}

export default function VideoCard({ video, compact = false }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} - 日皮视频`}
          title={`${video.title} 影视视频`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
        <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
          {video.categoryName}
        </span>
        <span className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-black/70 text-background-50 text-xs font-medium whitespace-nowrap flex items-center gap-1">
          <i className="ri-time-line" />
          {video.duration}
        </span>
        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
            <i className="ri-play-fill text-primary-600 text-2xl" />
          </span>
        </span>
      </div>
      <div className={compact ? "p-3" : "p-4"}>
        <h3
          className={`font-medium text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors ${
            compact ? "text-sm" : "text-base min-h-[2.75rem]"
          }`}
        >
          {video.title}
        </h3>
        {!compact && (
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
            {video.description}
          </p>
        )}
        <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-calendar-line" />
            {video.year}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line" />
            {formatViews(video.views)}
          </span>
          <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 whitespace-nowrap">
            {video.type}
          </span>
        </div>
      </div>
    </Link>
  );
}